import { request } from '@gameforge/http-client'

export type Translations = Record<string, string>

export const loadTranslations = async (locale: string) =>
  request(window.origin)
    .get(`/translations/${locale}.json`)
    .then(res => res.json<Translations>())
